package com.exura.pages.publicplans.orders

import com.exura.features.publicplans.domain.model.AnonymousPublicPlanOrder
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.minus
import kotlinx.datetime.plus
import kotlinx.datetime.toLocalDateTime


fun todayAnnotationDate(
    mode: OrdersPreviewRangeMode,
    now: LocalDateTime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()),
): LocalDate {
    val today = now.date
    return when (mode) {
        OrdersPreviewRangeMode.DAY -> today
        OrdersPreviewRangeMode.WEEK -> today.minus(DatePeriod(days = today.dayOfWeek.isoDayNumber - 1))
        OrdersPreviewRangeMode.MONTH -> LocalDate(today.year, today.monthNumber, 1)
    }
}

fun calculateOrderStats(
    orders: List<AnonymousPublicPlanOrder>,
    mode: OrdersPreviewRangeMode,
    now: LocalDateTime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
): List<OrderStats> {
    return when (mode) {
        OrdersPreviewRangeMode.DAY -> {
            val pastDays = 75
            val futureDays = 14
            val totalDays = pastDays + 1 + futureDays // 90

            val today = todayAnnotationDate(mode, now)
            val startOfGraph = today.minus(DatePeriod(days = pastDays))

            val dates = List(totalDays) { offset ->
                startOfGraph.plus(DatePeriod(days = offset))
            }

            calculateOrderStatsDaily(orders, dates)
        }

        OrdersPreviewRangeMode.WEEK -> {
            val pastWeeks = 47
            val futureWeeks = 4
            val totalWeeks = pastWeeks + 1 + futureWeeks // 52

            val currentWeekStart = todayAnnotationDate(mode, now)

            val startOfGraph = currentWeekStart.minus(DatePeriod(days = 7 * pastWeeks))

            val ranges = List(totalWeeks) { offset ->
                val start = startOfGraph.plus(DatePeriod(days = 7 * offset))
                val end = start.plus(DatePeriod(days = 6))
                start to end
            }

            calculateOrderStatsRanges(orders, ranges)
        }

        OrdersPreviewRangeMode.MONTH -> {
            val pastMonths = 32
            val futureMonths = 3
            val totalMonths = pastMonths + 1 + futureMonths // 36

            val currentMonthStart = todayAnnotationDate(mode, now)
            val startOfGraph = currentMonthStart.minus(DatePeriod(months = pastMonths))

            val ranges = List(totalMonths) { offset ->
                val start = startOfGraph.plus(DatePeriod(months = offset))
                val end = start.plus(DatePeriod(months = 1)).minus(DatePeriod(days = 1))
                start to end
            }

            calculateOrderStatsRanges(orders, ranges)
        }
    }
}
